var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.457,159.561a12.076,12.076,0,0,0,.833-1.13q24.42-42.35,48.845-84.7a9.276,9.276,0,0,1,2.018-2.415Q80.4,47.572,108.682,23.878c.3-.247.612-.467,1.222-.93-.321.765-.488,1.2-.686,1.628Q77.943,91.689,46.691,158.811a1.845,1.845,0,0,1-2,1.238q-21.588-.059-43.178-.037c-.351,0-.7.053-1.054.082Z",
    fill: "#1B8646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.313,176.666l92.372-16.345c-.346-.443-.589-.773-.852-1.086q-22.978-27.4-45.987-54.775a3.177,3.177,0,0,1-.69-3.628q11.973-32.74,23.831-65.524c.16-.439.351-.867.653-1.609l82.594,143.07H47.267Z",
    fill: "#1B8646"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.45d5699ff8fde34f8937ad6cc1257876.svg";
export { ForwardRef as ReactComponent };